export const PageComponent = {
	BriscoesImportOrderPage: "briscoesImportOrderPage",
	NZBloomExportBookingPage: "nzbloomExportBookingPage"
} as const;